import { connect } from 'react-redux';

import { RootState } from '../types';
import { getCoordinates, isFullscreenMapOpen } from '../selectors';
import { FullscreenMap } from '../components/FullscreenMap';
import { toggleFullscreenMap } from '../actions';

const FullscreenMapContainer = connect(
  (state: RootState) => ({
    isFullscreenMapOpen: isFullscreenMapOpen(state),
    coordinates: getCoordinates(state),
  }),
  {
    toggleFullscreenMap,
  },
)(FullscreenMap);
export { FullscreenMapContainer };
